enum fileStatusEnum{
    Failed = -1,
    Pending = 0,
    Ready = 1,
    FailedError = 2
}
export default fileStatusEnum;